<template>
  <!-- 企业形象 -->
  <div class="images">
    <el-upload class="avatar-uploader" :http-request="uploadfile" action="" :show-file-list="false" >
      <img v-if="formData.imgUrl" :src="formData.imgUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import api from '@/apis/recommend/images'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
      formData: {
        imgUrl: '',
      },
    }
  },
  mounted() {
    api.mine().then((res) => {
      if (res.code === 10000) {
        if (res.data) {
          this.formData = res.data
        }
      } else {
        this.$message.error(res.message)
      }
    })
  },
  methods: {
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val) {
      // console.log(val);
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.formData.imgUrl = res.data
          // this.$message.success(res.message)
          this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.images {
  .avatar {
    width: 60vw !important;
    height: 60vh !important;
  }
  .avatar-uploader-icon {
    font-size: 2rem !important;
    width: 60vw !important;
    height: 60vh !important;
    line-height: 55vh !important;
    text-align: center;
  }
}
</style>